import { removerComponenteReact, renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { Dict } from "app/utils/Dict";
import React, { useEffect } from "react";
import { MenuConsultaPesquisaOrcamento, MenuConsultasPesquisaOrcamentoContainer } from "./MenuConsultasPesquisaOrcamentoContainer";

export const useMenuConsultasPesquisaOrcamento = (props: MenuConsultaPesquisaOrcamento) => {
    
    const onRenderizarMenuConsultaPesquisaOrcamento = (passos?: Dict<string, () => void>) => {

        if (props.orcamentoSelecionado == null) {
            removerComponenteReact("menu-orcamento-pesquisa-react")
        } else {
            renderizarComponentReact(
                <MenuConsultasPesquisaOrcamentoContainer
                    orcamentoSelecionado={props.orcamentoSelecionado}
                    onSelecionadoMenu={() => {
                        $("[container]").hide();
                    }}
                    onVoltar={props.onVoltar}
                    passos={passos ?? props.passos}
                />,
                "menu-orcamento-pesquisa-react",
                true
            );
        }
    }

    useEffect(() => {
        const timeoutId = setTimeout(() => onRenderizarMenuConsultaPesquisaOrcamento())
        return () => {
            clearTimeout(timeoutId)
            removerComponenteReact("menu-orcamento-pesquisa-react")
        }
    }, [props.orcamentoSelecionado]);

    return onRenderizarMenuConsultaPesquisaOrcamento;
}